import React, { useState, useEffect } from 'react';
import { Form }                       from 'react-bootstrap';

function EditFloatValue( { index, boxMeasured, boxValue, onBoxChanged } ) {
    const [measured, setMeasured] = useState( 0 );
    const [value,    setValue]    = useState( 0 );
    const [valid,    setValid]    = useState( true );
    const floatRegex = /^[\d]+(\.[\d]+)?$/;

    const checkValidFloat = ( n ) => {
        if ( floatRegex.test(n) !== true) { 
            return false;
        } else { 
            return true;
        }
    }
        
    useEffect(() => {
        if (typeof boxMeasured !== 'undefined') {
            setMeasured(Number(boxMeasured));
        }
    }, [boxMeasured]); // Runs when initialData changes

    useEffect(() => {
        if (typeof boxValue !== 'undefined') {
            console.log("EditFloatValue: defined as " + boxValue );
            if ( boxValue !== null ) { 
                setValue(boxValue); 
            } else {
                setValue( 0.0 );
            }
            setValid(checkValidFloat( boxValue ));
        } else { 
            console.log("EditFloatValue: undefined");
            setValue(0.0);
        }
    }, [boxValue, checkValidFloat]); // Runs when initialData changes

    
    const handleChange = (event) => {
        const { value } = event.target;
            const v = checkValidFloat( value );
            onBoxChanged( index, value, v );
    }
    console.log("EditFloatValue(" + index + ", " + boxMeasured + ", " + boxValue + ")");
    return( <Form.Control className={' value-input-' + measured + '-' + valid } type="text" name="value" value={value} onChange={handleChange} placeholder="Value" /> );
}

export default EditFloatValue;
